module.exports = __webpack_public_path__ + "img/English-02.0465c16f.jpg";